<template>
    <div class="headerArea">

        <header :class="{mobileNavActive: mobileNav}">
            <div class="container">
                <div class="pure-g">

                    <!--Desktop Left & Mobile Header-->
                    <div class="pure-u-1 pure-u-md-24-24 pure-u-lg-14-24 left">
                        <nav class="mobileNav">
                            
                            <button class="menuBtn" @click="toggleMobileNav()">
                                <ion-icon v-show="!mobileNav" name="menu-outline"></ion-icon>
                                <ion-icon v-show="mobileNav" name="close"></ion-icon>
                            </button>

                            <Notifications v-if="$store.state.currentUser !== null"></Notifications>
                            
                            <router-link to="/" class="logo no-opacity">
                                <div class="logoInner">
                                    <img class="logoCircle" src="../assets/img/onemgl_logo_circle.png" alt="OneMgl" />
                                    <div>
                                        <p class="logoName">{{ siteName }}</p>
                                        <span class="logoCity">{{ $store.state.location.city }}</span>
                                    </div>
                                </div>
                            </router-link>

                            <router-link v-if="!currentUser" to="/register" class="loginBtn rightBtn"><ion-icon name="person-circle"></ion-icon></router-link>

                            <a href="#0" v-if="locationsEnabled" @click.prevent="toggleLocation" class="toggleLocation icon">
                                <ion-icon name="earth"></ion-icon>
                            </a>

                            <a href="#0" @click="switchDarkMode($event)" class="toggleDarkMode icon" :class="{ active: darkMode }">
                                <ion-icon v-if="!darkMode" name="moon"></ion-icon>
                                <ion-icon v-else name="moon"></ion-icon>
                            </a>

                            <template v-if="currentUser">
                                <router-link :to="`/user/${currentUser.uid}`" class="avatarLink">
                                    <span>{{currentUser.displayName | getFirstName}}</span>
                                    <div class="avatar" :style="{ backgroundImage: 'url(' + currentUser.photoURL + '?width=150&height=150)' }"></div>
                                </router-link>
                            </template>
                        </nav>
                        <nav :class="{show: mobileNav}">
                            <router-link :class="{hide: mobileNav}" to="/" class="logo no-opacity">
                                <div class="logoInner">
                                    <img class="logoCircle" src="../assets/img/onemgl_logo_circle.png" alt="OneMgl" />
                                    <div>
                                        <p class="logoName">{{ siteName }}</p>
                                        <span class="logoCity">{{ $store.state.location.city }}</span>
                                    </div>
                                </div>
                            </router-link>
                            <router-link to="/">Home</router-link>
                            <router-link to="/events">Events</router-link>
                            <router-link to="/workshops">Workshops</router-link>
                            <router-link to="/about">About Us</router-link>
                            <!-- <router-link to="/news">News</router-link> -->
                            <router-link to="/stories">Stories</router-link>
                            <router-link to="/members">Members</router-link>
                            <router-link to="/listings">Listings</router-link>
                        </nav>
                    </div>
                    
                    <!--Desktop Right-->
                    <div class="pure-u-1 pure-u-md-24-24 pure-u-lg-10-24 right">
                        <nav :class="{show: mobileNav}">
                            
                            <a href="#0" v-if="locationsEnabled" @click.prevent="toggleLocation" class="toggleLocation icon hint hint--bottom" data-hint="Change Location" :class="{ active: showLocationNav }">
                                <ion-icon name="earth"></ion-icon>
                            </a>

                            <a href="#0" @click="switchDarkMode($event)" class="toggleDarkMode icon hint hint--bottom" data-hint="Dark Mode" :class="{ active: darkMode }">
                                <ion-icon v-if="!darkMode" name="moon"></ion-icon>
                                <ion-icon v-else name="moon"></ion-icon>
                            </a>

                            <!--Notifications-->
                            <Notifications v-if="$store.state.currentUser !== null && !mobileNav"></Notifications>

                            <!--Login & Sign Up-->
                            <template v-if="!currentUser">
                                <router-link to="/login">Login</router-link>
                                <router-link to="/register" class="btn green">Sign Up</router-link>
                            </template>
                            
                            <template v-if="currentUser">

                                <!--Chat-->
                                <router-link to="/chat" class="icon hint hint--bottom chatIcon" data-hint="Messages">
                                    <ion-icon name="chatbubble-ellipses"></ion-icon>
                                </router-link>

                                <!--Create Menu-->
                                <details class="dropdown details-reset details-overlay d-inline-block createMenu">
                                    <summary class="d-inline" aria-haspopup="true">
                                        <a class="icon hint hint--bottom createIcon" data-hint="Create">
                                            <ion-icon name="add-circle"></ion-icon>
                                        </a>
                                    </summary>
                                    <ul class="dropdown-menu dropdown-menu-sw">
                                        <li class="titleArea divider">
                                            <h4 class="title">Create</h4>
                                        </li>
                                        <li><router-link to="/posts?action=create" class="dropdown-item">Post</router-link></li>
                                        <li><router-link to="/videos?action=create" class="dropdown-item">Video</router-link></li>
                                        <li><router-link to="/listings?action=create" class="dropdown-item">Listing</router-link></li>
                                    </ul>
                                </details>
                                
                                <!--Avatar-->
                                <router-link :to="`/user/${currentUser.uid}`" class="avatarLink">
                                    <div class="avatar" :style="{ backgroundImage: 'url(' + currentUser.photoURL + '?width=150&height=150)' }"></div>
                                </router-link>

                                <!--Show More Menu-->
                                <details class="dropdown details-reset details-overlay d-inline-block showMoreMenu">
                                    <summary class="p-2 d-inline" aria-haspopup="true">
                                        <a class="icon">
                                            <ion-icon name="ellipsis-horizontal"></ion-icon>
                                        </a>
                                    </summary>

                                    <ul class="dropdown-menu dropdown-menu-sw">
                                        <li class="titleArea divider">
                                            <p>Signed in as: <br><span>{{ currentUser.displayName }}</span></p>
                                        </li>
                                        <li class="divider"><router-link :to="`/user/${currentUser.uid}`" class="dropdown-item">Profile</router-link></li>
                                        <li><router-link to="/chat" class="dropdown-item">Messages</router-link></li>
                                        <li><router-link to="/settings" class="dropdown-item">Settings</router-link></li>
                                        <li><a @click.prevent="logout" href="#0" class="dropdown-item">Sign Out</a></li>
                                    </ul>
                                </details>
                            </template>

                        </nav>
                    </div>

                </div>
            </div>
            <div class="mobileNavDimmer"></div>
        </header>

        <!-- Location Sub Header-->
        <div v-if="locationsEnabled" class="subHeader" :class="{active: showLocationNav}">
            <a href="#0" @click.prevent="showLocationNav = false" class="closeBtn icon">
                <ion-icon name="close-outline"></ion-icon>
            </a>
            <div class="container">
                <Locations @updateComponents="updateComponents" :key="locationsKey"></Locations>
            </div>  
        </div>

    </div>
</template>

<script>
import countryData from 'country-state-city'
const fb = require('../firebaseConfig.js')
import Locations from '@/components/Locations'
import MemberStatus from '@/components/MemberStatus'
import Notifications from '@/components/Notifications'

export default {
    components: {
        Locations,
        MemberStatus,
        Notifications
    },

    data(){
        return{
            siteName: '',
            searchMode: false,
            mobileNav: false,
            showLocationNav: false,
            locationsEnabled: true,
            location: null,
            allStates: null,
            allCities: null,
            locationsKey: 0
        }
    },

    watch: {
        '$route' () {
            this.mobileNav = false
            window.scrollTo(0,0)

            if(this.showLocationNav){
                this.showLocationNav = false
            }
        }
    },

    created(){
        this.siteName = this.$store.state.site.name
    },

    methods: {
        logout() {
            // Disconnected
            fb.rdb.ref(`/status/${this.$store.state.currentUser.uid}`).set({
                status: 'offline',
                timestamp: fb.firebase.database.ServerValue.TIMESTAMP
            })
            
            fb.auth.signOut().then(() => {
                this.$store.dispatch('clearData')
                this.$router.push('/home')
            }).catch(err => {
                console.log(err)
            })
        },
        switchDarkMode(e){
            e.preventDefault()
            this.$store.dispatch('toggleDarkMode')
        },
        search(e){
            e.preventDefault()
            this.searchMode = !this.searchMode
        },
        toggleMobileNav(){
            this.mobileNav = !this.mobileNav
        },
        toggleLocation(){

            this.showLocationNav = !this.showLocationNav
            this.location = this.$store.state.location

            console.log('Switch Location: ', this.location)

            this.allStates = countryData.getStatesOfCountry(this.location.countryId)
            this.allCities = countryData.getCitiesOfState(this.location.stateId)
        },
        updateCountry(){
            this.allStates = countryData.getStatesOfCountry(this.location.countryId)
            this.location.state = ''
            this.location.stateId = ''
            this.location.city = ''
            this.location.cityId = ''
            this.allCities = null
        },
        updateState(){
            this.allCities = countryData.getCitiesOfState(this.location.stateId)
            this.location.city = ''
            this.location.cityId = ''
        },
        goToLocationPage(){

            let newLocation = this.location

            let selectedCountry = countryData.getCountryById(newLocation.countryId)
            let selectedState = countryData.getStateById(newLocation.stateId)
            let selectedCity = countryData.getCityById(newLocation.cityId)

            newLocation.country = selectedCountry.name
            newLocation.state = selectedState.name
            newLocation.city = selectedCity.name

            window.localStorage.setItem('defaultLocation', newLocation.city)

            this.$store.dispatch('updateLocation', newLocation)

            this.showLocationNav = false

            this.$emit('updateComponents')
        },
        updateComponents(){
            this.locationsKey += 1
            this.showLocationNav = false
            this.$emit('updateComponents')
        }
    },

    computed: {
        currentUser(){
            return this.$store.state.currentUser
        },
        darkMode(){
            return this.$store.state.darkMode
        },
        hasSubNav(){
            let hasSubNav = false
            if(this.$route.meta){
                if(this.$route.meta.hasSubNav){
                    hasSubNav = true
                }
            }
            return hasSubNav
        }
    },
    
    filters: {
        getFirstName(value){
            if(!value) return ''
            return value.split(' ').slice(0, -1).join(' ')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Header.vue